import React, { useMemo } from "react";
import type { Schedule } from "@/types";
import CalendarModal from "./CalendarModal.tsx";

interface EmployeeCalendarModalProps {
    open: boolean;
    onClose: () => void;
    employeeId: string;
    employeeName: string;
    schedule: Schedule;
    problematicShiftIds?: string[];
    shiftConstraintBreaches?: { [shiftId: string]: string[] };
    periodStartDate?: string;
    periodEndDate?: string;
    onShiftClick?: (shiftId: string) => void;
    onPrev?: () => void;
    onNext?: () => void;
    hasPrev?: boolean;
    hasNext?: boolean;
}

const EmployeeCalendarModal: React.FC<EmployeeCalendarModalProps> = (
    {
        open,
        onClose,
        employeeId,
        employeeName,
        schedule,
        problematicShiftIds,
        shiftConstraintBreaches,
        periodStartDate,
        periodEndDate,
        onShiftClick,
        onPrev,
        onNext,
        hasPrev,
        hasNext,
    }) => {
    const filteredShifts = useMemo(() => {
        return schedule.shifts.filter(shift => shift.employee?.userId === employeeId);
    }, [schedule.shifts, employeeId]);

    const employee = useMemo(() => {
        return schedule.employees.find(e => e.userId === employeeId);
    }, [schedule.employees, employeeId]);

    return (
        <CalendarModal
            open={open}
            onClose={onClose}
            title={employeeName}
            filteredShifts={filteredShifts}
            schedule={schedule}
            problematicShiftIds={problematicShiftIds}
            shiftConstraintBreaches={shiftConstraintBreaches}
            periodStartDate={periodStartDate}
            periodEndDate={periodEndDate}
            badgeContentType="role"
            employee={employee}
            onShiftClick={onShiftClick}
            onPrev={onPrev}
            onNext={onNext}
            hasPrev={hasPrev}
            hasNext={hasNext}
        />
    );
};

export default EmployeeCalendarModal;
